import React from "react"
import { arePropsEmpty } from "../utils/arePropsEmpty"
import { SemanticHeader } from "../../shared/components/SemanticHeader"

interface ProfileSectionProps {
  id: string
  label: string
  component: React.ComponentType<any>
  sectionProps?: Record<string, any>
  padX?: boolean
}

const ProfileSection: React.FC<ProfileSectionProps> = ({
  id,
  label,
  component: SectionComponent,
  sectionProps = {},
  padX = true,
}) => {
  if (arePropsEmpty(sectionProps)) {
    return null
  }
  return (
    <section id={id}>
      <SemanticHeader
        text={label}
        type="sectionHeader"
        headerLevel="h3"
        styleOverrides="mt-0 mb-1.5 px-6"
      />
      <div className={padX ? "px-6" : ""}>
        <SectionComponent {...sectionProps} />
      </div>
    </section>
  )
}

export default ProfileSection
